import { useEffect } from "react";
import {
  Alert,
  AlertProps,
  Box,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import posthog from "posthog-js";
import { getEnv } from "@ace/env";
import CloseIcon from "@mui/icons-material/Close";

export const GenericArchaxToastError = (
  <span>
    An error has occurred. If the issue persists, please contact{" "}
    <Link href={`mailto:${getEnv("ARCHAX_EMAIL_SUPPORT")}`}>
      {getEnv("ARCHAX_EMAIL_SUPPORT")}
    </Link>
    .
  </span>
);

interface ToastProps {
  title: string | React.ReactNode;
  content?: string | React.ReactNode;
  onClick?: () => void;
  type: "success" | "error" | "info" | "warning";
  "data-cy"?: string;
  sx?: AlertProps["sx"];
  onClose?: () => void;
}

export const Toast = (props: ToastProps): JSX.Element => {
  useEffect(() => {
    // we don't send the props.content as that can have reference and order id which are identifiable.

    posthog.capture(`Toast:${props.type} - ${props.title}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Alert
      severity={props.type}
      onClick={props.onClick}
      data-cy={props["data-cy"]}
      sx={{
        width: "320px",
        "& .MuiAlert-message": {
          flex: 1,
        },
        ...props.sx,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        gap={1}
        alignItems="flex-start"
      >
        <Box>
          <Typography>{props.title}</Typography>
          <Typography variant="body2">{props.content}</Typography>
        </Box>
        {props.onClose && (
          <IconButton
            sx={{ p: 0 }}
            onClick={(e) => {
              e.preventDefault();
              if (props.onClose) {
                props.onClose();
              }
            }}
          >
            <CloseIcon sx={{ color: "#ffffff20" }} />
          </IconButton>
        )}
      </Stack>
    </Alert>
  );
};
